import React from 'react'

import withSlidableJobPopulation from '../HOCs/withSlidableJobList'

import JobBlock from './../jobBlock'
import DataSource from './dataSource'

const FeaturedJobs = withSlidableJobPopulation(
    JobBlock,
    (props) => DataSource(props.languageCode),
    false,
    'section-featured-jobs'
)

export default FeaturedJobs
